import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const ColorDot = (props) => {
  const onClick = () => {
    props.onClick(props.color);
  };

  return (
    <Box
      tabIndex="-1"
      sx={{
        outline: "none",
        cursor: "pointer",
        position: "relative",
        width: "18px",
        height: "18px",
        margin: "3px",
        boxSizing: "border-box",
        borderRadius: "50%",
        backgroundColor: props.color,
        "&:hover": {
          width: "20px",
          height: "20px",
          margin: "2px",
          boxShadow:
            "0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%), 0px 1px 3px 0px rgb(0 0 0 / 20%)",
        },
      }}
    >
      <Box
        aria-label={props.colorKey}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        onClick={onClick}
      />
    </Box>
  );
};

function GroupedEl({ palette, selected, handleColorOptionClick }) {
  const groupArray = (array, perGroupItem = 3) => {
    const result = [];
    for (let i = 0; i < array.length; i += perGroupItem) {
      result.push(array.slice(i, i + perGroupItem));
    }
    return result;
  };

  const array = Object.keys(palette).map((key) => {
    return (
      <ColorDot
        key={key}
        color={`${palette[key]}`}
        onClick={handleColorOptionClick}
        colorKey={key}
        selected={palette[key] === selected}
      />
    );
  });

  const nestedArray = groupArray(array);

  return (
    <>
      {nestedArray?.map((el, i) => (
        <Box
          key={i}
          component="li"
          sx={{
            px: "0.5rem",
            py: "0.2rem",
            overflow: "auto",
            display: "flex",
          }}
        >
          {el}
        </Box>
      ))}
    </>
  );
}

export const ColorPicker = ({ palette, value, handleValue }) => {
  const [selected, setSelected] = useState(() => value);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorOptionClick = (color) => {
    handleValue(color);
    setSelected(color);
    handleClose();
  };

  return (
    <>
      <Button
        id="color-picker-button"
        aria-controls={open ? "color-picker-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleOpen}
        type="button"
        name="color"
        endIcon={<ArrowDropDownIcon />}
        sx={(theme) => {
          return { bgcolor: theme.palette.action.hover };
        }}
      >
        <Box
          sx={{
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            ...(selected
              ? { backgroundColor: `${selected}` }
              : { border: "1px solid gray" }),
            // border: "1px solid gray",
          }}
        />
      </Button>

      <Menu
        id="color-picker-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        aria-labelledby="color-picker-button"
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <GroupedEl
          palette={palette}
          selected={selected}
          handleColorOptionClick={handleColorOptionClick}
        />
      </Menu>
    </>
  );
};
